import React from "react";
import PropTypes from "prop-types";
import { withPrefix } from "gatsby";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import { Stack } from "@nib/layout";
import Heading from "@nib-components/heading";
import Expander from "@nib-components/expander";
import InfoBox from "@nib/info-box";
import colors from "@nib-components/colors";
import { ChevronDownSystemIcon, ChevronUpSystemIcon, ClockGraphicIcon } from "@nib/icons";

const StyledInfoBox = styled(InfoBox)`
  padding: 0;
  ${breakpoint("md")`
    width: 50%;
  `}
`;

const StyledButton = styled.button`
  display: flex;
  padding: 2rem 0;
  width: 100%;
  justify-content: space-between;
  border-bottom: 2px solid ${colors.sneezy};
`;

const StyledDiv = styled.div`
  align-self: center;
`;

const StyledSection = styled.section`
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  text-align: left;
  ${breakpoint("md")`
    width: 75%;
  `}
`;

const StyledContainer = styled.div`
  &:first-child {
    border-top: 2px solid ${colors.sneezy};
  }
  ${breakpoint("md")`
    width: 80%;
    margin: 0 auto;
  `}
`;

const ExpandedSection = ({
  onToggleExpanded,
  title,
  subTitle,
  timeToComplete,
  expanded,
  children,
  moduleId,
  isMobile,
  image,
}) => {
  return (
    <StyledContainer>
      <StyledButton onClick={onToggleExpanded}>
        {/* TODO hack, we need an image uploader
            this currently uses module id to src image named with id */}
        {!isMobile && (
          <img
            src={withPrefix(`/assets/images/products/${moduleId}-100x90.jpg`)} //TODO:: use image.url eventually
            alt={image.alt}
          />
        )}
        <StyledSection>
          <Stack space={{ xs: 3 }}>
            <Heading component="h3" size={{ xs: 4 }}>
              {title}
            </Heading>
            {!isMobile && (
              <Heading component="h5" size={{ xs: 6 }}>
                {subTitle}
              </Heading>
            )}
            {timeToComplete && (
              <StyledInfoBox icon={ClockGraphicIcon} withBorder={false} withBoxShadow={false}>
                {timeToComplete}
              </StyledInfoBox>
            )}
          </Stack>
        </StyledSection>
        <StyledDiv>{expanded ? <ChevronUpSystemIcon /> : <ChevronDownSystemIcon />}</StyledDiv>
      </StyledButton>
      <Expander expanded={expanded}>{children}</Expander>
    </StyledContainer>
  );
};

ExpandedSection.propTypes = {
  onToggleExpanded: PropTypes.func.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  timeToComplete: PropTypes.string,
  expanded: PropTypes.bool,
  children: PropTypes.node,
  moduleId: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
};

export default ExpandedSection;
